import * as React from 'react';
export const afterpayclearpaySvg = React.forwardRef(
  function afterpayclearpaySvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B2FCE4',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.593 9.227-7.906-4.435c-2.32-1.302-5.221.325-5.221 2.93v.455c0 .411.226.792.592.996l1.493.838c.438.246.985-.062.985-.553V8.326c0-.566.63-.92 1.133-.636l6.847 3.842a.724.724 0 0 1 0 1.272l-6.847 3.842c-.504.283-1.133-.07-1.133-.637v-.602c0-2.605-2.9-4.234-5.223-2.93l-7.906 4.435a3.338 3.338 0 0 0 0 5.861l7.906 4.436c2.32 1.301 5.223-.325 5.223-2.931v-.455c0-.411-.226-.79-.592-.996l-1.493-.84c-.438-.246-.985.062-.985.553v1.132c0 .566-.63.92-1.133.636l-6.847-3.842a.726.726 0 0 1 0-1.274l6.847-3.842c.504-.283 1.133.07 1.133.637v.602c0 2.606 2.9 4.234 5.221 2.93l7.906-4.435a3.334 3.334 0 0 0 0-5.857Z',
        fill: '#000',
      }),
    );
  },
);
afterpayclearpaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var afterpayclearpay = {
  category: 'brand',
  colorable: false,
  name: 'afterpayclearpay',
  svg: afterpayclearpaySvg,
};
